
import { Component, Vue } from 'vue-property-decorator';
import { getCancelDetialList, getHandleInfo, getVersion } from '@/api/cancel-detial';
import { iSelectOptionsList } from '@/interface/cancel-detail';
import { iCancelDetail } from '@/interface/result';
import { eDeviceStatus } from '@/interface/eCommand';
import moment from 'moment';
import { toast } from '../../../utils/common';
import UserFeedBackDetail from './components/UserFeedBackDetail.vue';
import { log } from 'console';
@Component({
  filters: {
    yyyy_mm_dd(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD');
    },
    yyyy_mm_dd_two(val: number) {
      return moment(val * 1000).format('YYYY/MM/DD HH:mm:ss');
    },
  },
  components: { UserFeedBackDetail },
})
export default class extends Vue {
  private dataValue: Date[] = [];
  private detailTable: iCancelDetail[] = [];
  private loading: boolean = true;
  private total: number = 0;
  private detailDialogVisible: boolean = false;
  private pickerBeginDateBefore: { disabledDate: Function } = {
    disabledDate(time: any) {
      return time.getTime() > Date.now();
    },
  };
  private searchValue: {
    start: number;
    end: number;
    search: string;
    has_remark: number;
    has_handle: number;
    reason_code: number;
    page: number;
    page_size: number;
    device: number;
    nickname: string;
    user_id: number | null;
    area_name: string;
    area_id: number | null;
    machine_id: number | null;
    remark: string;
    is_has_pic: number | null;
    revoke_type: number | null;
    version: string;
  } = {
    start: 0,
    end: 0,
    search: '',
    has_remark: 1, // 备注默认1
    has_handle: 0,
    reason_code: -1, // -1=全部，其他为对应原因
    page: 1,
    page_size: 30,
    device: -1, // -1=全部，其他为对应原因
    nickname: '',
    user_id: null,
    area_name: '',
    area_id: null,
    machine_id: null,
    remark: '',
    is_has_pic: -1,
    revoke_type: -1,
    version: '',
  };
  private detailInfo: iCancelDetail = {
    cancel_at: 0,
    has_handle: 0,
    id: 0,
    last_ping: 0,
    mac: '',
    machine_id: 0,
    nickname: '',
    node_id: '',
    node_name: '',
    order_end: 0,
    order_start: '',
    reason: '',
    reason_code: '',
    remark: '',
    status: 0,
    uid: 0,
    game_name: '',
    qq_number: '',
    x_version: '',
    imgs: [],
    deviceStatusName: '',
    feedback_type: 0,
    gid: '',
  };
  private versionList: object[] = [];
  private remarkOptions: iSelectOptionsList[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '有备注',
      value: 1,
    },
    {
      label: '无备注',
      value: 2,
    },
  ];
  private handleOptions: iSelectOptionsList[] = [
    {
      label: '全部',
      value: 0,
    },
    {
      label: '已处理',
      value: 1,
    },
    {
      label: '未处理',
      value: 2,
    },
  ];
  deviceOptions: iSelectOptionsList[] = [
    {
      label: '全部客户端',
      value: -1,
    },
    {
      label: 'PC',
      value: 1,
    },
    {
      label: '安卓',
      value: 2,
    },
    {
      label: 'IOS',
      value: 5,
    },
  ];
  picList: iSelectOptionsList[] = [
    {
      label: '全部',
      value: -1,
    },
    {
      label: '有图片',
      value: 1,
    },
    {
      label: '无图片',
      value: 2,
    },
  ];
  revokeList: iSelectOptionsList[] = [
    {
      label: '全部',
      value: -1,
    },
    {
      label: '撤单反馈',
      value: 1,
    },
    {
      label: '自助反馈',
      value: 2,
    },
  ];
  private reasonOptions: iSelectOptionsList[] = [
    { label: '全部', value: -1 },
    { label: '延迟高', value: 1 },
    { label: '没有想玩的游戏', value: 2 },
    { label: '机器配置不行', value: 3 },
    { label: '卡在LOGO连接页面，无法连接云电脑', value: 4 },
    { label: '其他原因', value: 5 },
    { label: '帧数低', value: 6 },
    { label: '安卓黑屏', value: 7 },
    { label: '安卓端操作不了游戏', value: 8 },
    { label: '卡顿', value: 9 },
    { label: '免账号失败', value: 10 },
    { label: '游戏启动失败', value: 11 },
    { label: '黑屏', value: 12 },
    { label: '没有加速器', value: 13 },
    { label: '频繁断开', value: 14 },
    { label: '游戏存档', value: 15 },
    { label: '机器配置低', value: 16 },
  ];
  private columnList: { label: string; prop: string; isTemp: boolean; width?: number; style?: string }[] = [
    {
      label: '反馈时间',
      prop: 'cancel_at',
      isTemp: false,
    },

    {
      label: '问题类型',
      prop: 'reasons',
      isTemp: true,
    },
    {
      label: '原因备注',
      prop: 'remark',
      isTemp: false,
    },
    {
      label: '用户昵称(ID)',
      prop: 'nickname',
      isTemp: true,
      width: 160,
    },
    {
      label: '商户名称(ID)',
      prop: 'node_name',
      isTemp: true,
      width: 140,
    },
    {
      label: '云更新用户ID',
      prop: 'ygx_uid',
      isTemp: true,
      width: 140,
    },
    {
      label: '设备ID',
      prop: 'machine_id',
      isTemp: true,
    },
    {
      label: '启动游戏',
      prop: 'game_name',
      isTemp: true,
    },
    {
      label: 'QQ',
      prop: 'qq_number',
      isTemp: false,
    },
    {
      label: '版本',
      prop: 'x_version',
      isTemp: false,
    },
    {
      label: '类型',
      prop: 'feedback_type',
      isTemp: false,
    },
    // {
    //   label: '开始时间',
    //   prop: 'order_start',
    //   isTemp: true,
    // },
    // {
    //   label: '注销时间',
    //   prop: 'order_end',
    //   isTemp: false,
    // },
    // {
    //   label: '设备当前状态',
    //   prop: 'status',
    //   width: 140,
    //   isTemp: false,
    // },
    // {
    //   label: '客户端',
    //   prop: 'x_device',
    //   width: 140,
    //   isTemp: false,
    // },
    {
      label: '处理状态',
      prop: 'has_handle',
      width: 120,
      isTemp: false,
    },
  ];
  dataChange(datavalue: Date[]) {
    this.searchValue.start = Math.floor(datavalue[0].getTime() / 1000);
    this.searchValue.end = Math.floor(datavalue[1].getTime() / 1000) + 3600 * 24 - 1;
    this.searchValue.page = 1;
    this.getDetailList();
  }
  searchBlur() {
    this.searchValue.page = 1;
    this.getDetailList();
  }
  searchEnter(event: any) {
    // event.target.blur();
    this.searchValue.page = 1;
    this.getDetailList();
  }
  remarkChange() {
    this.searchValue.page = 1;
    this.getDetailList();
  }
  deviceChange() {
    const deciceType = this.searchValue.device;
    this.getVersion(deciceType);
    this.searchValue.page = 1;
    this.getDetailList();
  }
  handleSizeChange(page_size: number) {
    this.searchValue.page = 1;
    this.searchValue.page_size = page_size;
    this.getDetailList();
  }
  handleCurrentChange(page: number) {
    this.searchValue.page = page;
    this.getDetailList();
  }
  handleData(data: iCancelDetail) {
    this.loading = true;
    this.getHandleResult(data);
  }
  handleDetail(data: iCancelDetail) {
    this.detailDialogVisible = true;
    const status = data.status;
    this.detailInfo = data;
    this.detailInfo.deviceStatusName = this.deviceStatus(status ? status : 0);
  }
  /**
   * 设置默认时间
   */
  getTimeFn() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.dataValue = [start, end]; // 默认
    this.searchValue.start = Math.round(new Date(this.formatDate(start) + ' 00:00:00').getTime() / 1000);
    this.searchValue.end = Math.round(new Date(this.formatDate(end) + ' 23:59:59').getTime() / 1000);
    this.getDetailList();
  }
  /**
   * 格式化时间
   */
  formatDate(date: Date) {
    let myyear: string | number = date.getFullYear();
    let mymonth: string | number = date.getMonth() + 1;
    let myweekday: string | number = date.getDate();

    if (mymonth < 10) {
      mymonth = '0' + mymonth;
    }
    if (myweekday < 10) {
      myweekday = '0' + myweekday;
    }
    return myyear + '-' + mymonth + '-' + myweekday;
  }
  deviceStatus(status: number) {
    switch (status) {
      case (status = eDeviceStatus.USE):
        return '使用';
      case (status = eDeviceStatus.FREE):
        return '空闲';
      case (status = eDeviceStatus.OFFLINE):
        return '离线';
      case (status = eDeviceStatus.FAULT):
        return '故障';
      case (status = eDeviceStatus.MAINTAIN):
        return '维护';
      case (status = eDeviceStatus.DELETE):
        return '删除';
      default:
        return '';
    }
  }
  async getDetailList() {
    this.loading = true;

    try {
      const res = await getCancelDetialList({ ...this.searchValue });
      this.loading = false;
      if (res) {
        this.detailTable = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }
  async getVersion(x_device: number) {
    try {
      const res = await getVersion({ x_device: x_device });
      if (res) {
        // this.versionList = res.data.x_versions;
        // this.versionList.unshift('全部');
        this.versionList = [];
        this.searchValue.version = '';
        const data = res.data.x_devices_versions;

        this.versionList.unshift({ index: -1, value: '', label: '全部版本' });
        data.forEach((item: any, index: number) => {
          const { x_version, x_device } = item;
          let keyValue = '';
          if (x_device === 1) {
            keyValue = 'Win ';
          } else if (x_device === 2) {
            keyValue = 'Android ';
          } else if (x_device === 5) {
            keyValue = 'IOS ';
          }
          const lable = keyValue + x_version;
          this.versionList.push({ id: index, value: x_version, label: lable });
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  async getHandleResult(data: iCancelDetail) {
    try {
      const res = await getHandleInfo({ id: data.id, has_handle: 1 });
      this.loading = false;
      if (res && res.code == 0) {
        toast('状态处理成功', 'success');
        data.has_handle = 1;
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      this.loading = false;
      console.log(error);
    }
  }
  mounted() {
    this.getVersion(-1);
    this.getTimeFn();
  }
}
